import withHydrationOnDemand from 'react-hydration-on-demand';

import Footer from './index';

const FooterWithHydrationOnDemand = withHydrationOnDemand({
  on: ['idle'],
})(Footer);

export default FooterWithHydrationOnDemand;
